import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe } from "lucide-react";

const LOGO_URL = process.env.REACT_APP_LOGO_URL;

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#030305] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="relative">
                <div className="absolute inset-0 rounded-full bg-white/10 blur-lg scale-125" />
                <img src={LOGO_URL} alt="Imperial Exim Trading LLC" className="relative h-14 w-auto brightness-125" />
              </div>
              <div className="leading-tight">
                <span className="block text-white font-bold text-sm tracking-wide">IMPERIAL EXIM</span>
                <span className="block text-[#DC143C] font-semibold text-xs tracking-[0.15em]">TRADING LLC</span>
              </div>
            </div>
            <p className="text-[#9CA3AF] text-sm leading-relaxed max-w-xs">
              Your trusted partner for trailer trading, metal supply, and general cargo solutions worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-white font-semibold text-sm uppercase tracking-[0.2em] mb-5">Quick Links</h4>
            <div className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/catalog", label: "Products" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="block text-[#9CA3AF] text-sm hover:text-[#DC143C] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Categories */}
          <div className="md:col-span-3">
            <h4 className="text-white font-semibold text-sm uppercase tracking-[0.2em] mb-5">Categories</h4>
            <div className="space-y-3">
              {[
                { to: "/catalog/skeleton_trailers", label: "Skeleton Trailers" },
                { to: "/catalog/flatbed_trailers", label: "Flatbed Trailers" },
                { to: "/catalog/metals", label: "Metals Trading" },
                { to: "/catalog/cargo", label: "General Cargo" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`footer-cat-${link.to.split('/').pop()}`}
                  className="block text-[#9CA3AF] text-sm hover:text-[#DC143C] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="md:col-span-2">
            <h4 className="text-white font-semibold text-sm uppercase tracking-[0.2em] mb-5">Contact</h4>
            <div className="space-y-3 text-[#9CA3AF] text-sm">
              <div className="flex items-start gap-2">
                <Mail size={14} className="mt-0.5 shrink-0 text-[#DC143C]" />
                <span>info@iet.ae</span>
              </div>
              <div className="flex items-start gap-2">
                <Phone size={14} className="mt-0.5 shrink-0 text-[#DC143C]" />
                <span>+971 4 2868441</span>
              </div>
              <div className="flex items-start gap-2">
                <Phone size={14} className="mt-0.5 shrink-0 text-[#DC143C]" />
                <span>+971 56 56 88227</span>
              </div>
              <div className="flex items-start gap-2">
                <MapPin size={14} className="mt-0.5 shrink-0 text-[#DC143C]" />
                <span>Office No 202, Al Tawhidi 2, Bur Dubai, Dubai, UAE</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#9CA3AF] text-xs">
            &copy; {new Date().getFullYear()} Imperial Exim Trading LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-1 text-[#9CA3AF] text-xs">
            <Globe size={12} />
            <span>Global Trading Solutions</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
